// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__DidAe","Header":"Home_Header__3QokK","SubHead":"Home_SubHead__Y55ca","SocialMediaLinks":"Home_SocialMediaLinks__2GJP3","Icon":"Home_Icon__dawAh"};